import { render, staticRenderFns } from "./NRWBetriebsbeschreibungGew.vue?vue&type=template&id=aa10ac8c&"
import script from "./NRWBetriebsbeschreibungGew.vue?vue&type=script&lang=js&"
export * from "./NRWBetriebsbeschreibungGew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports